var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseCard',{staticClass:"ce-available-balance-card flex column align-center justify-center"},[_c('p',{staticClass:"value flex"},[_vm._v(_vm._s(_vm.formattedBalance))]),_c('p',{staticClass:"label flex"},[_vm._v("SALDO")])])}
var staticRenderFns = []

export { render, staticRenderFns }